import React, { useCallback }  from "react";
import {
	DataGridPro,
	GridColDef,
	GridColumns,
	GridRenderCellParams,
	GridToolbar,
	GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
	useGridApiRef,
} from "@mui/x-data-grid-pro";
import { Box, Chip, Link } from "@material-ui/core";
import { runProductsDataGridProps } from "./RunProductsDataGrid.d";
import appStyles from "../../AppStyles";

const RunProductsDataGrid: React.FC<runProductsDataGridProps> = (props: runProductsDataGridProps) => {
	const { 
		products,
	} = props;

	const apiRef = useGridApiRef();
	const classes = appStyles();

	const columns: GridColumns = [
		{
			...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
		},
			{ field: "productImageUrl", headerName: "", width: 100,
			renderCell: (params: GridRenderCellParams) => { return (
				<img src={(params.value?.replace(".jpg", "_200x200.jpg")?.replace(".png", "_200x200.png") ?? "/images/noimage.png")} alt="product" width="64" height="64" />
			)}
		},
		{
			field: "sku",
			headerName: "Sku",
			width: 150,
			disableColumnMenu: true,
			resizable: false,
			renderCell: (params) => { return (<Link href={`${process.env.REACT_APP_PRODUCT_URL}/product/${params.value}`} className={classes.link} target="_blank">{params.value}</Link>) }
		},

		
		{ field: "description", headerName: "Description", width: 240, disableColumnMenu: true, resizable: false },
		{
			field: "fulfilmentLocationInventory.locationId",
			type: "number",
			headerName: "Location Id",
			width: 150,
			disableColumnMenu: true,
			resizable: false,
			renderCell: (params) => { return (<div>{params.row.fulfilmentLocationInventory?.locationId}</div>) }
		},
		{
			field: "fulfilmentLocationInventory.totalSoh",
			type: "number",
			headerName: "Soh",
			width: 150,
			disableColumnMenu: true,
			resizable: false,
			renderCell: (params) => { return (<div>{params.row.fulfilmentLocationInventory?.totalSoh}</div>) }
		},
		{
			field: "fulfilmentLocationInventory.saleableSoh",
			type: "number",
			headerName: "Avail",
			width: 150,
			disableColumnMenu: true,
			resizable: false,
			renderCell: (params) => { return (<div>{params.row.fulfilmentLocationInventory?.saleableSoh}</div>) }
		},
		{
			field: "totalMovementQty",
			type: "number",
			headerName: "Movement",
			width: 150,
			disableColumnMenu: true,
			resizable: false,
		},
	];

	const OrderDetailsPanel = ({ row: rowProp }) => {
		const detailColumns: GridColDef[] = [
			{ field: "sku", headerName: "Sku", width: 100 },
			{ field: "locationId", type: "number", headerName: "Location Id", width: 100 },
			{ field: "locationName", headerName: "Location", width: 200 },
			{ field: "totalSoh", type: "number", headerName: "SOH", width: 100 },
			{ field: "saleableSoh", type: "number", headerName: "Avail", width: 100 },
			{ field: "onPurchaseOrderQuantity", type: "number", headerName: "PO", width: 100 },
			{ field: "inTransitQuantity", type: "number", headerName: "Transit", width: 100 },
			{ field: "pendingCustomerOrderQuantity", type: "number", headerName: "CO", width: 100 },
			{ field: "inStoreOrderQuantity", type: "number", headerName: "Instore Co", width: 100 },
			{ field: "faultyPosReturnQuantity", type: "number", headerName: "Faulty", width: 100 },
			{ field: "displayQuantity", type: "number", headerName: "Display", width: 100 },
			{ field: "minQty", type: "number", headerName: "Min", width: 100 },
			{ field: "maxQty", type: "number", headerName: "Max", width: 100 },
			{
				field: "suggestedQty",
				headerName: "Suggest",
				width: 100,
				renderCell: (params) => { return (<Box sx={{ bgcolor: params.row.suggestedQty > 0 ? 'yellow' : 'transparent' }} minHeight="100%" minWidth="100%" display='flex' textAlign="center" flexDirection="column" justifyContent="center">{params.row.suggestedQty}</Box>) }
		 	},
			{ field: "isRanged", type: "boolean", headerName: "Ranged", width: 100 },
		];
		return (
			<DataGridPro
				autoHeight
				rows={rowProp.destinationLocationInventory}
				columns={detailColumns}
				sx={{ borderRadius: 0, marginLeft: 2, marginTop: 1}}
				hideFooter
				columnVisibilityModel={{ id: false }}
				getRowId={(row) => `datagrid-details-${row.sku}-${row.locationId}` }
				density="compact"
			/>
		);
	};

	const getDetailPanelContent = useCallback(({ row }) => <OrderDetailsPanel row={row} />, []);
	const getDetailPanelHeight = useCallback(({ row }) => 70 + row.destinationLocationInventory.length * 52, []); // 70 approx header row height, 52 approx row height

	return (
		<DataGridPro
			apiRef={apiRef}
			autoHeight
			density="standard"
			rows={products ?? []}
			columns={columns}
			paginationMode="client"
			rowsPerPageOptions={[25, 50, 100]}
			pagination
			// onSelectionModelChange={(i) => setRowSelection(i)}
			// selectionModel={rowSelection}
			getRowId={(row) => `${row.sku}` }
			getDetailPanelHeight={getDetailPanelHeight}
			getDetailPanelContent={getDetailPanelContent}
			components={{
				Toolbar: GridToolbar,
			}}
			initialState={{
				pagination: {
					pageSize: 25,
				},
				sorting: {
					sortModel: [{ field: 'totalMovementQty', sort: 'desc' }],
				  },
			}}
		/>
	);
};

export default RunProductsDataGrid;
